$(function () {
    'use strict';

    function UpdateCustomBibShipDate() {

        var dt = new Date(); //current data, clients timezone
        dt.setTime(dt.getTime() + dt.getTimezoneOffset() * 60 * 1000); //change to utc
        var offset = -4 * 60; //Timezone offset for EST in minutes.
        var d = new Date(dt.getTime() + offset * 60 * 1000); //create datetime in est
        var targetDay = 4;// thursday

        if (d.getDay() > 0) {
            d.setDate(d.getDate() + 14 + targetDay - d.getDay());
        } else {
            d.setDate(d.getDate() + 7 + (( targetDay - d.getDay()) % 7));
        }

        var shipDate = (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear();
        if ($('#custom-bib-ship-date').length) {
            $('#custom-bib-ship-date')[0].innerHTML = shipDate;
        }
        $('.custom-bib-ship-date').html(shipDate);
        $('input#customBibShipDate').val(shipDate);

        var ad = new Date();
        ad.setTime(d.getTime() + 3 * 86400000)

        var arriveDate = (ad.getMonth() + 1) + '/' + ad.getDate() + '/' + ad.getFullYear();
        if ($('#custom-bib-arrive-date').length) {
            $('#custom-bib-arrive-date')[0].innerHTML = arriveDate;
        }
        $('.custom-bib-arrive-date').html(arriveDate);
        $('input#customBibArriveDate').val(arriveDate);


    }

    const bibColorBlackRGB = 'rgb(0, 0, 0)';
    const bibColorRedRGB = 'rgb(252, 69, 69)';

    function BibBuilder(componentId, previewId) {
        this.quill = undefined;

        this.componentId = componentId;
        this.previewId = (typeof previewId !== 'undefined') ? previewId : 'preview';

        this.productSingleObject = JSON.parse($('[data-product-json]').html());

        this.toolbarOptions = [
            [{'align': []}],
            ['bold', 'italic'],
            [{'color': [bibColorRedRGB, bibColorBlackRGB]}],
            [{'font': []}],
            [{'size': ['small', false, 'large', 'huge']}],
        ];

        this._init();
    }

    BibBuilder.prototype.updatePreviewImages = function () {
        var self = this;
        var customText = this.getText();
        var customHtml = this.getHTML();

        //  Remove some odd unicode value in the strin "\uFEFF"
        customHtml = customHtml.replace(/[^\x00-\x7F]/g, "");  // limit to ascii 0-127 only
        $("#customBibHtml").val(customHtml);

        if (typeof this.xhrUpdateRequest !== 'undefined' && self.PendingPreviewImage === true) {
            this.xhrUpdateRequest.abort();
        }

        self.PendingPreviewImage = true;
        $(".spinner").show();

        $('form.product-form button').attr('disabled', 'disabled').prop('disabled', true);

        var renderServerUrl = 'https://roadid-render-html.herokuapp.com/render/';

        var fullBibRequest = renderServerUrl + "png-blob?quality=10&width=563&height=431&format=png";
        var customOnlyRequest = renderServerUrl + "jpg-blob?quality=100&width=2750&height=1000&zoom=10&format=jpg";

        var fullBibBodyCssStyles = "background-image: url('https://static.roadid.com/imagesv3/Sponsorship/roadid-standard-custom-bibs-customizer-9999.png?x=1');background-repeat: no-repeat;padding-left: 250px;padding-top: 20px;";
        var customOnlyBodyCssStyles = "";

        var customBibColor = $("#customBibColor").val();

        var fullBibHtmlTemplate = GetCustomBibHtmlTemplate(customHtml, fullBibBodyCssStyles, customBibColor, 275);

        var customOnlyHtmlTemplate = GetCustomBibHtmlTemplate(customHtml, customOnlyBodyCssStyles, customBibColor, 276);
        customOnlyHtmlTemplate = customOnlyHtmlTemplate.replace(/252, 69, 69/g, '0, 0, 0');

        
        $.when(
            $.ajax({url: fullBibRequest, type: "POST", data: fullBibHtmlTemplate}),
            $.ajax({url: customOnlyRequest, type: "POST", data: customOnlyHtmlTemplate})
        ).done(function (fullBibResult, customOnlyResult) {
            $("#customBibPreviewUrl").val(fullBibResult[0].BibPreivewImgUrl);
            $(".zoomImg").attr('src', fullBibResult[0].BibPreivewImgUrl);
            $("#FeaturedImage-product-custombib-template").attr('src', fullBibResult[0].BibPreivewImgUrl);

            $("#customBibPrintingUrl").val(customOnlyResult[0].BibPreivewImgUrl);

            $("#customBibColor").val(customBibColor);

//             analytics.track("Customized Bibs", {
//               text: customText,
//               html: customHtml,
//               imageURL: fullBibResult[0].BibPreivewImgUrl
//             });
        }).fail(function (jqXHR, error, errorThrown) {
            console.error(error);
        }).always(function (jqXHR, textStatus) {
            $(".spinner").hide();
            self.PendingPreviewImage = false;

            $('form.product-form button').removeAttr('disabled').removeProp('disabled');
        });

    };

    BibBuilder.prototype._init = function () {
        this.component = document.getElementById(this.componentId);
        this.preview = document.getElementById(this.previewId);

        var self = this;
        if (!this.component) {
            throw "Missing builder container";
        }

        this.quill = new Quill(this.component, {
            theme: 'snow',
            placeholder: "Jimbo's Jamboree",
            modules: {
                toolbar: this.toolbarOptions,
            }
        });

        // Override Color Handler because Printer only accepts on color.
        this.quill.getModule("toolbar").addHandler("color", function (value) {
            $("#customBibColor").val(value);
            this.quill.formatText(0, 9999, 'color', value);
        });

        //Default settings
        //  In order to have the editor default to large and centered.
        //  Inorder for center to work there must be a new line, hence '\n'
        //  Some Text must be present inorder to show the selected attributes, hence the space.
        //  Note: This also then never shows the place holder text.
        this.quill.setContents([
            {
                insert: ' \n', attributes: {
                align: 'center',
                size: 'large'
            }
            }
        ]);

        //set focus to clearly show this is editable.
        this.quill.focus();

        function updatePreviewDebounce() {
            self.updatePreviewImages();
        }

        function validateText() {
            var errorText = $("#builderTextError");

            var isValid = self.isTextValid();
            if (isValid) {
                errorText.hide();
            }
        }

        this.quill.on('text-change', _.debounce(updatePreviewDebounce, 400));

        this.quill.on('text-change', validateText);

        this.quill.on('text-change', function (delta, oldDelta, source) {
            if (source == 'api') {
                //  console.log("An API call triggered this change.");
            } else if (source == 'user') {
                // console.log("A user action triggered this change.");
            }
        });
    };

    BibBuilder.prototype.setText = function (text) {
        return this.quill.insertText(0, text);
    };

    BibBuilder.prototype.getHTML = function () {
        return this.quill.root.innerHTML;
    };

    BibBuilder.prototype.getText = function () {
        return $(this.getHTML()).text().trim();
    }

    BibBuilder.prototype.getOptions = function () {
        var toolbar = this.quill.getModule('toolbar');
        return toolbar.controls.map(function (control) {
            return control[0];
        });
    };


    BibBuilder.prototype.isTextValid = function () {
        var customText = this.getText();
        if (customText !== undefined && customText != null && customText.length > 0) {
            return true;
        }
        else {
            return false;
        }
    };

    BibBuilder.prototype.isReasonableEventDate = function () {
        var ar = new Date($('input#customBibArriveDate').val());
        var ed = new Date($('input#event-date').val());
       
        return ar <= ed;
    };

    BibBuilder.prototype.validateOnSubmitClick = function () {
        var errorText = $("#builderTextError");

        var isReasonableEventDate = window.bb.isReasonableEventDate();
        var isValid = window.bb.isTextValid();
        if (isValid) {
            if (!isReasonableEventDate) {
                errorText.html("Error: Custom Bibs will not arrive in time for your event, please order Standard Bibs");
                errorText.show();
    
                event.preventDefault();
                return false;
            }
            else {
                errorText.hide();
                return true;
            }
        }
        else {
            errorText.html("Error: Text is required for a Custom Bib");
            errorText.show();

            event.preventDefault();
            return false;
        }
    };

    if (document.getElementById('custom-bib-ship-date') || $('.custom-bib-ship-date').length) {
        UpdateCustomBibShipDate();
    }

    if (document.getElementById("builder")) {
        window.bb = new BibBuilder("builder", "preview");
    }

    function GetCustomBibHtmlTemplate(customText, bodyCssStyles, customBibColor, customBibHtmlWidth) {
        return "<html>" +
            "<head>" +
            "<link rel='stylesheet' type='text/css' href='https://staticstoragee2app.blob.core.windows.net/css/custom-bibs/reset.css'>" +
            "<link rel='stylesheet' type='text/css' href='https://staticstoragee2app.blob.core.windows.net/css/custom-bibs/custom-bib-base.css'>" +
            "<style>" +
            "em, i { font-style: italic; }" +
            "strong, b { font-weight: bold; }" +
            ".ql-font-serif { font-family: serif !important; }" +
            ".ql-font-monospace { font-family: monospace !important; }" +
            "body {" +
            bodyCssStyles +
            "}" +
            ".custom-bib-html{ width: " + customBibHtmlWidth + " }" +
            "</style>" +
            "</head>" +
            "<body>" +
            "<div class='custom-bib-html ql-editor'>" +
            "<div style='color: " + customBibColor + "'>" +
            customText +
            "</div>" +
            "</div>" +
            "</body>" +
            "</html>";
    }
});
